module.exports = __webpack_public_path__ + "img/ear-deaf.0e136f95.svg";